// src/pages/admin/AdminAppointments.js
import React, { useEffect, useState } from "react";
import api from "../../api";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import AdminSidebar from "./AdminSidebar";
import "./AdminAppointments.css";
import { useNavigate } from "react-router-dom";

export default function AdminAppointments() {
  const [appointments, setAppointments] = useState([]);
  const [availableSlots, setAvailableSlots] = useState({});
  const [selectedDate, setSelectedDate] = useState("");

  const token = localStorage.getItem("token");
  const email = localStorage.getItem("userEmail");
  const navigate = useNavigate();

  // ✅ Redirect if not admin
  // useEffect(() => {
  //   if (!email) return;
  //   if (email !== "garishtha.wellness@gmail.com") {
  //     navigate("/profile");
  //   }
  // }, [email, navigate]);

  // Fetch appointments
  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const res = await api.get("/admin/appointments", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAppointments(res.data || []);
    } catch (err) {
      console.error("Failed to fetch appointments:", err);
    }
  };

  // Cancel appointment
  const cancelAppointment = async (date, time, bookedBy) => {
    if (!window.confirm("Are you sure you want to cancel this appointment?")) return;

    try {
      await api.delete(`/admin/appointments/${date}/${time}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("Appointment cancelled and email sent.");
      fetchAppointments();
    } catch (err) {
      console.error(err);
      alert("Failed to cancel appointment.");
    }
  };

  // Save available slots
  const saveAvailableSlots = async () => {
    try {
      await api.post(
        "/admin/appointments/available-slots",
        { date: selectedDate, slots: availableSlots },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Slots updated successfully.");
    } catch (err) {
      console.error(err);
      alert("Failed to save slots.");
    }
  };

  // Fetch unavailable slots when date changes
  useEffect(() => {
    if (!selectedDate) return;

    const fetchUnavailableSlots = async () => {
      try {
        const res = await api.get(
          `/admin/appointments/unavailable-slots/${selectedDate}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const data = res.data?.slots || {};

        const updatedSlots = {};
        times.forEach((t) => {
          updatedSlots[t] = !(data[t] === false);
        });
        setAvailableSlots(updatedSlots);
      } catch (err) {
        console.error("Failed to fetch unavailable slots:", err);
      }
    };

    fetchUnavailableSlots();
  }, [selectedDate]);

  const toggleSlot = (time) => {
    setAvailableSlots((prev) => ({
      ...prev,
      [time]: !prev[time],
    }));
  };

  const times = [
    "09:00", "10:00", "11:00", "12:00",
    "13:00", "14:00", "15:00", "16:00",
    "17:00", "18:00"
  ];

  return (
    <>
      <Header />
      <div className="admin-layout">
        <div className="admin-body">
          <AdminSidebar />
          <div className="admin-content">
            <h2>Appointment Schedule</h2>

            {appointments.length === 0 ? (
              <p>No appointments booked.</p>
            ) : (
              <table className="appointments-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Client</th>
                    <th>Reason</th>
                    <th>Meet</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {appointments.map(({ date, time, booked_by, reason, meet_link }) => (
                    <tr key={`${date}-${time}`}>
                      <td>{date}</td>
                      <td>{time}</td>
                      <td>{booked_by}</td>
                      <td>{reason}</td>
                      <td>{meet_link}</td>
                      <td>
                        <button
                          className="cancel-btn"
                          onClick={() => cancelAppointment(date, time, booked_by)}
                        >
                          Cancel
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            {/* Manage Slots */}
            <div className="slot-management">
              <h3>Manage Available Slots</h3>
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
              <div className="slots-grid">
                {times.map((time) => (
                  <button
                    key={time}
                    className={`slot-btn ${availableSlots[time] === false ? "unavailable" : "available"}`}
                    onClick={() => toggleSlot(time)}
                  >
                    {time}
                  </button>
                ))}
              </div>
              <button
                className="save-slots-btn"
                onClick={saveAvailableSlots}
                disabled={!selectedDate}
              >
                Save Slots
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
